exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".formCard[data-v-3873c47c]{border:none!important;padding:0}.tab-list[data-v-3873c47c]{display:flex;cursor:pointer;overflow-x:auto}.tab-list div[data-v-3873c47c]{padding:5px;margin:5px;border:1px solid #ccc;border-radius:5px;white-space:nowrap;user-select:none;transition:background-color .3s}.tab-list div[data-v-3873c47c]:hover{background-color:#0aa46e}.active-tab[data-v-3873c47c]{background-color:#007bff;color:#fff}.fade-enter-active[data-v-3873c47c],.fade-leave-active[data-v-3873c47c]{transition:opacity .5s}.fade-enter[data-v-3873c47c],.fade-leave-to[data-v-3873c47c]{opacity:0}.custom-slide-enter-active[data-v-3873c47c],.custom-slide-leave-active[data-v-3873c47c]{transition:transform .5s}.custom-slide-enter[data-v-3873c47c],.custom-slide-leave-to[data-v-3873c47c]{transform:translateX(100%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3873c47c","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/payment/Tab.vue
// module id = 1506
// module chunks = 0